import type {BaseStoreFragment} from '~/composables/useStoreValidation.generated'

export const useStoresStore = defineStore('stores', {
  state: () => ({
    storesMap: {} as Record<string, BaseStoreFragment>,
    accessTimes: {} as Record<string, number>,
  }),
  actions: {
    getStore(slug: string) {
      return this.storesMap[slug]
    },
    setStore(store: BaseStoreFragment) {
      this.storesMap[store.slug] = store
      this.accessTimes[store.slug] = Date.now()

      // 캐시 크기 제한 (예: 최대 20개 스토어)
      const MAX_CACHE_SIZE = 100
      if (Object.keys(this.storesMap).length > MAX_CACHE_SIZE) {
        // 가장 오래전에 접근한 스토어 제거
        const oldestSlug = Object.entries(this.accessTimes).sort(([, a], [, b]) => a - b)[0][0]
        delete this.storesMap[oldestSlug]
        delete this.accessTimes[oldestSlug]
      }
    },
    hasStore(slug: string) {
      return !!this.storesMap[slug]
    },
  },
  getters: {},
})
